import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TaskListDetailsModal {
  id: string | number | null;
  open: boolean;
  extra: any;
  selectedTaskDetails: any;
  selectedSubtaskDetails: any;
  showTaskCreationModal: any;
  isSubtask: boolean;
  onClose?: "openProjectModal" | "openActivityModal";
  showSubTaskUpdateDrawer: boolean;
  isSubtaskUpdate: boolean;
  currentSubtaskId: null | number;
  refreshSubTaskList: boolean;
  phaseResponse: {
    id: null;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
  };
  projectResponse: {
    id: null;
    status: string;
    name: string;
  };
  activityResponse: {
    id: null;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
  };
  taskResponse: {
    id: null;
    status: string;
    name: string;
  };
  allowEdit: boolean;
  subtaskAllowEdit?: boolean;
  subtaskOpenInEdit?: boolean;
  approvalData?: {
    approvalLinkId: string;
    approvalStage: "Checker" | "Approver" | "Verifier";
    stateApprovals?: any[];
  } | null;
  isFromWorkUI: boolean,
}
const initialState: { data: TaskListDetailsModal } = {
  data: {
    id: null,
    open: false,
    extra: null,
    selectedTaskDetails: null,
    showTaskCreationModal: false,
    showSubTaskUpdateDrawer: false,
    selectedSubtaskDetails: null,
    isSubtask: false, // used for create subtask
    isSubtaskUpdate: false,
    currentSubtaskId: null,
    refreshSubTaskList: false,
    phaseResponse: {
      id: null,
      name: "",
      status: "",
      startDate: "",
      endDate: "",
    },
    projectResponse: {
      id: null,
      status: "",
      name: "",
    },
    activityResponse: {
      id: null,
      name: "",
      status: "",
      startDate: "",
      endDate: "",
    },
    taskResponse: {
      id: null,
      status: "",
      name: "",
    },
    allowEdit: true,
    onClose: "openActivityModal",
    approvalData: null,
    isFromWorkUI: false,
  },
};

export const TaskListDetailsModalSlice = createSlice({
  name: "TaskListDetailsModalSlice",
  initialState,
  reducers: {
    updateTaskListDetailsModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetTaskListDetailsModalSlice(state) {
      state.data = initialState.data;
    },
    setTaskApprovalData(state, action: PayloadAction<TaskListDetailsModal["approvalData"]>) {
      state.data.approvalData = action.payload;
    },
  },
});

export const {
  updateTaskListDetailsModalSlice,
  resetTaskListDetailsModalSlice,
  setTaskApprovalData
} = TaskListDetailsModalSlice.actions;

export const RootPageRenderSlice = createSlice({
  name: "RootPageRenderSlice",
  initialState: initialState,
  reducers: {
    updateRootPageRenderState: (state, action) => {
      // call when entering to root page
      state.data = action.payload;
    },
  },
});

export const { updateRootPageRenderState } = RootPageRenderSlice.actions;
